/** Dispatched on `document` by editors that manage their own state (e.g. EditorJS). */
export const FORM_DIRTY_EVENT = 'cms:form-dirty';

/** Omitting the detail means dirty; editors report `false` again once the content is back to its saved state. */
export interface FormDirtyEventDetail {
  dirty?: boolean;
}
